import { useAutoAnimate } from '@formkit/auto-animate/react';

import { EventMatching } from './event-matching';

import { Button } from '@/components/ui/button';
import { ORDER_OUTCOME, SIZE_DECIMALS } from '@/constants/solana';
import { useFetchUserPositionState } from '@/hooks/solana/query/use-fetch-user-position-state';
import { useAuthenticatedWallet } from '@/hooks/ui/use-authenticated-wallet';
import { cn } from '@/lib/utils';

type Props = {
  id: number;
  shares: string;
  setShares: (shares: string) => void;
  matchingAmount: number | null;
  outcome: ORDER_OUTCOME;
};

export const EventSellSharesInput = ({
  id,
  shares,
  setShares,
  matchingAmount,
  outcome,
}: Props) => {
  const { publicKey } = useAuthenticatedWallet();
  const { data: userPositionState } = useFetchUserPositionState(publicKey, id);
  const holdingShares =
    (outcome === ORDER_OUTCOME.YES
      ? Number(userPositionState?.yesShares || 0)
      : Number(userPositionState?.noShares || 0)) / SIZE_DECIMALS;

  const [parent] = useAutoAnimate();

  const handleSetPercentage = (percentage: number) => {
    const sharesValue = ((holdingShares * percentage) / 100).toString();
    setShares(sharesValue);
  };

  const handleChangeShares = (value: string) => {
    if (value && !/^[0-9.,]+$/.test(value)) return;

    if (value.startsWith('.')) {
      value = '0' + value;
    }

    setShares(value.replace(',', '.'));
  };
  return (
    <>
      <div className="flex flex-row gap-[10px]">
        <div className="min-w-[120px] text-[14px] text-[#767676]">
          Shares to Sell
        </div>
        <input
          className="h-[40px] w-full bg-transparent text-end text-[24px]"
          value={shares}
          type="number"
          placeholder="0"
          onChange={(e) => handleChangeShares(e.target.value)}
        />
      </div>
      <div
        className={cn(
          'flex w-full flex-row justify-between',
          matchingAmount === null ? 'justify-end' : 'justify-between',
        )}
      >
        {matchingAmount !== null && (
          <div ref={parent}>
            <EventMatching amount={matchingAmount} />
          </div>
        )}

        <div className="flex flex-row justify-end gap-[10px] text-[14px]">
          <Button
            size="medium"
            variant="accent"
            onClick={() => handleSetPercentage(25)}
          >
            25%
          </Button>
          <Button
            size="medium"
            variant="accent"
            onClick={() => handleSetPercentage(50)}
          >
            50%
          </Button>
          <Button
            size="medium"
            variant="accent"
            onClick={() => handleSetPercentage(100)}
          >
            MAX
          </Button>
        </div>
      </div>
      <div className="flex flex-row text-[14px]">
        <div className="grow text-[#767676]">Shares Available</div>
        <div>{holdingShares}</div>
      </div>
    </>
  );
};
